///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.show_rfi = abcsetup.consumer_rfp.show_rfi || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.show_rfi = {
    formRenderInstance: null,

    init() {
        abcsetup.setTitle('Edit Consumer RFP Event');

        require('formBuilder');
        require('formBuilder/dist/form-render.min');

        this.initFormBuilder();
        this.initListeners();

        // abcsetup.consumer_rfp.common.init();
        //abcsetup.consumer_rfp.common.setupEventBindings();
    },

    initListeners: () => {
        $(document).on('click', '#submit-rfi-form', function () {
            $('#rfi_data').val(JSON.stringify(abcsetup.consumer_rfp.show_rfi.formRenderInstance.userData));
            var isValid = true;
            var form = $('#rfi-form');
            form.find(':required').each(function () {
                window.fieldValidate.runValidations(this);
                if (!this.validity.valid) {
                    console.log('invalid: ', this);
                    isValid = false;
                }
            });

            if (isValid)
                form.submit();
        });
        $(document).on('change','.selling_for_another_retailer', function() {
            if($(this).val() =='1') {
                $('.selling_for_another_retailer_who').attr('disabled',false).closest('div').show();
            } else {
                $('.selling_for_another_retailer_who').val('').attr('disabled',true).closest('div').hide();
            }
        }).trigger('change');

        $('.selling_for_another_retailer').trigger('change');

        $(document).on('change', '.audit_history', function () {
            var label = $("label[for='" + $('.facility_last_audited').attr('id') + "']");

            if ($('.audit_history').is(":checked")) {
                $('.audit_history').val(1);
                label.children(".formbuilder-required").remove();
                $('.facility_last_audited').removeClass("invalid").attr("required", false);
                $('.facility_last_audited').next('.errorMsg').remove();
            } else {
                $('.audit_history').val(0);
                label.append('<span class="formbuilder-required">*</span>');
                $('.facility_last_audited').attr("required", true);
            }
        });

        $("input[name*='audit_history']").trigger('change');
    },
    initFormBuilder: () => {
        var rfp_id = $('#rfp_id').val();
        var formRenderOptions = {
            formData: JSON.parse($('#form_data').val())
        }
        abcsetup.consumer_rfp.show_rfi.formRenderInstance = $('#render-container').formRender(formRenderOptions);

        if($('#read_only').val() == 1) {
            $('.rendered-form :input').attr('readonly', true).attr('disabled', true);
        }
    }
}
